import React from "react";
import { Outlet } from "react-router-dom";
import CardNav from "./CardNav";

const PublicLayout = () => {
  const navItems = [
    {
      label: "Features",
      bgColor: "#0D0716",
      textColor: "#fff",
      links: [
        {
          label: "Blockchain",
          href: "/sign-o/blockchain",
          ariaLabel: "Blockchain Security",
        },
        {
          label: "Identity (KYC)",
          href: "/sign-o/kyc",
          ariaLabel: "Identity Verification",
        },
        {
          label: "Smart Dashboard",
          href: "/sign-o/dashboard-features",
          ariaLabel: "Dashboard Features",
        },
      ],
    },
    {
      label: "Compliance",
      bgColor: "#170D27",
      textColor: "#fff",
      links: [
        {
          label: "Legal Validity",
          href: "/sign-o/legal",
          ariaLabel: "Legal Validity",
        },
        {
          label: "Audit Trails",
          href: "/sign-o/blockchain",
          ariaLabel: "Audit Trails",
        },
      ],
    },
    {
      label: "Company",
      bgColor: "#271E37",
      textColor: "#fff",
      links: [
        { label: "About", href: "#", ariaLabel: "About Us" },
        { label: "Contact", href: "#", ariaLabel: "Contact Us" },
      ],
    },
  ];

  return (
    <>
      <CardNav
        items={navItems}
        baseColor="rgba(0, 0, 0, 0.8)"
        menuColor="#fff"
        buttonBgColor="#5227FF"
        buttonTextColor="#fff"
      />
      <Outlet />
    </>
  );
};

export default PublicLayout;
